var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M24,7 L0,7 L0,5 L24,5 L24,7 Z M24,13 L0,13 L0,15 L24,15 L24,13 Z M24,21 L0,21 L0,23 L24,23 L24,21 Z","transform":"translate(0 -5)"}));
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 18"};

module.exports = Menu;

Menu.default = Menu;
